export interface LanguageConfig {
  code: string
  name: string
  nativeName: string
  flag: string
  scriptType?: 'latin' | 'devanagari' | 'chinese'
  ttsSupport?: boolean
  sttSupport?: boolean
  ttsLanguageCode?: string
  sttLanguageCode?: string
}

export const SUPPORTED_LANGUAGES: LanguageConfig[] = [
    {
        code: 'ja',
        name: 'Japanese',
        nativeName: '日本語',
        flag: '🇯🇵',
        scriptType: 'chinese',
        ttsSupport: true,
        sttSupport: true,
        ttsLanguageCode: 'ja-JP',
        sttLanguageCode: 'ja-JP'
    },
    {
        code: 'es',
        name: 'Spanish',
        nativeName: 'Español',
        flag: '🇪🇸',
        scriptType: 'latin',
        ttsSupport: true,
        sttSupport: true,
        ttsLanguageCode: 'es-ES',
        sttLanguageCode: 'es-ES'
    },
    {
        code: 'tl',
        name: 'Tagalog',
        nativeName: 'Tagalog',
        flag: '🇵🇭',
        scriptType: 'latin',
        ttsSupport: true,
        sttSupport: true,
        ttsLanguageCode: 'fil-PH',
        sttLanguageCode: 'fil-PH'
    },
    {
        code: 'de',
        name: 'German',
        nativeName: 'Deutsch',
        flag: '🇩🇪',
        scriptType: 'latin',
        ttsSupport: true,
        sttSupport: true,
        ttsLanguageCode: 'de-DE',
        sttLanguageCode: 'de-DE'
    },
    {
        code: 'fr',
        name: 'French',
        nativeName: 'Français',
        flag: '🇫🇷',
        scriptType: 'latin',
        ttsSupport: true,
        sttSupport: true,
        ttsLanguageCode: 'fr-FR',
        sttLanguageCode: 'fr-FR'
    },
    {
        code: 'it',
        name: 'Italian',
        nativeName: 'Italiano',
        flag: '🇮🇹',
        scriptType: 'latin',
        ttsSupport: true,
        sttSupport: true,
        ttsLanguageCode: 'it-IT',
        sttLanguageCode: 'it-IT'
    },
    {
        code: 'pt',
        name: 'Portuguese',
        nativeName: 'Português',
        flag: '🇵🇹',
        scriptType: 'latin',
        ttsSupport: true,
        sttSupport: true,
        ttsLanguageCode: 'pt-PT',
        sttLanguageCode: 'pt-PT'
    },
    {
        code: 'sm',
        name: 'Samoan',
        nativeName: 'Gagana Samoa',
        flag: '🇼🇸',
        scriptType: 'latin',
        ttsSupport: false,
        sttSupport: false,
        ttsLanguageCode: 'en-US', // Fallback to English
        sttLanguageCode: undefined
    },
    {
        code: 'to',
        name: 'Tongan',
        nativeName: 'Lea Fakatonga',
        flag: '🇹🇴',
        scriptType: 'latin',
        ttsSupport: false,
        sttSupport: false,
        ttsLanguageCode: 'en-US', // Fallback to English
        sttLanguageCode: undefined
    },
    {
        code: 'hi',
        name: 'Hindi',
        nativeName: 'हिन्दी',
        flag: '🇮🇳',
        scriptType: 'devanagari',
        ttsSupport: true,
        sttSupport: true,
        ttsLanguageCode: 'hi-IN',
        sttLanguageCode: 'hi-IN'
    },
    {
        code: 'zh',
        name: 'Mandarin Chinese',
        nativeName: '中文',
        flag: '🇨🇳',
        scriptType: 'chinese',
        ttsSupport: true,
        sttSupport: true,
        ttsLanguageCode: 'cmn-CN',
        sttLanguageCode: 'cmn-Hans-CN'
    },
]

// Helper functions for language operations
export function getLanguageByCode(code: string): LanguageConfig | undefined {
  return SUPPORTED_LANGUAGES.find(lang => lang.code === code)
}

export function getLanguageName(code: string): string {
  return getLanguageByCode(code)?.name || code
}

export function getLanguageNativeName(code: string): string {
  return getLanguageByCode(code)?.nativeName || code
}

export function isLanguageSupported(code: string): boolean {
  return SUPPORTED_LANGUAGES.some(lang => lang.code === code)
}

export function getLanguagesWithTTS(): LanguageConfig[] {
  return SUPPORTED_LANGUAGES.filter(lang => lang.ttsSupport !== false)
}

export function getLanguagesWithSTT(): LanguageConfig[] {
  return SUPPORTED_LANGUAGES.filter(lang => lang.sttSupport !== false)
}
